import * as React from 'react';
import {
  RadioGroup,
  RadioButton as Radio,
} from '@spaced-out/ui-design-system/lib/components/RadioButton';
import {classify} from 'src/utils/classify';


export {RadioGroup};

export function RadioPair({
  className,
  value,
  label,
}: {
  className?: string | null | undefined;
  value: unknown;
  label: React.ReactNode;
  isHorizontal?: boolean;
}) {
  return (
    // @ts-expect-error - TS2769 - No overload matches this call.
    <Radio value={value} classNames={{wrapper: className ? className : ''}}>
      <label className={classify(className)}>
        <span>{label}</span>
      </label>
    </Radio>
  );
}
